import React from 'react';
import { Button, Input } from '@ktag/styleguide/dist/react';
import { useTranslation } from 'react-i18next';
import { useTracking } from '../../utils/tracking/TrackingContext';
import useAppState from '../../AppStore';

const Share = () => {
  const { t } = useTranslation('agisviewer');
  const { Tracking } = useTracking();
  const location = window.location.href;
  const addNotification = useAppState((state) => state.addNotification);

  return (
    <div className="tooldialog__wrapper">
      <div className="tooldialog__wrapper-content">
        <Input name="shareUrl" value={location} readonly />
        <Button
          additionalClassNames="button__max-width"
          onClick={async () => {
            Tracking.Share.share(location);
            await navigator.clipboard.writeText(location);
            addNotification({
              id: Date.now().toString(),
              title: t('share_notification_title'),
              message: t('share_notification_message'),
              type: 'information',
            });
          }}
        >
          {t('share_button_label')}
        </Button>
      </div>
    </div>
  );
};

export default Share;
